// The link to the diagnostic, built so the reader keeps the language they were
// already reading in.
//
// /start holds its own language state and reads ?lang (see the route's
// validateSearch); without the parameter the form opens with nothing selected
// and asks a question the person has already answered by being on an
// Azerbaijani or English page. The Russian pages are the ones this bites
// hardest: Russian is the unprefixed default, so their links carried no ?lang
// at all and a Russian reader was sent back to the language picker.
//
// Package is deliberately NOT a parameter here. It belongs only where a tier
// was actually chosen — the two plan buttons on the pricing page — and those
// are static HTML. Everywhere else the choice happens later, in the form.

export type StartLang = "az" | "ru" | "en";

export function startHref(lang: StartLang): string {
  return `/start?lang=${lang}`;
}
